var map = {
	"./academy/atom.gif": "8f6f",
	"./academy/book-quill.gif": "2b52",
	"./academy/cap-diploma.gif": "501c",
	"./academy/chalkboard-welcome.gif": "4696",
	"./academy/column-flame.gif": "6c7d",
	"./academy/divider-owl.gif": "e125",
	"./academy/donkey-emc2.gif": "8300",
	"./academy/email-quill.gif": "387b",
	"./academy/globe.gif": "150e",
	"./academy/lightbulb.gif": "c1d9",
	"./academy/owl-graduate.gif": "207a",
	"./academy/teacher.gif": "cead",
	"./construction-sign.gif": "d035",
	"./guestbook.gif": "d029",
	"./internet-explorer.gif": "5727",
	"./netscape-now.gif": "bfcd",
	"./new.gif": "a3c9",
	"./under-construction.gif": "41f6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2ef9";